<template>
  <div id="report-summary">
   <dash-header :pages="courseSubmitterBreadCrumbsPages" :dashboardTitle="'Combined Assessment Summary'" v-if="userRole === 'telas_course_submitters'" />
   <dash-header :pages="breadCrumbsPages" :dashboardTitle="'Combined Assessment Summary'" v-else/>
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="userRole && userRole === 'telas_course_submitters'"/>
      <dash-sidebar
      defaultSelectedKeys="0"
      :menuItems="commonMenuItems.admin"
      v-else-if="userRole && userRole === 'telas_telas_administrator'"/>
      <dash-sidebar
      defaultSelectedKeys="0"
      :menuItems="commonMenuItems.assessors"
      v-else />
      <a-layout-content :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }">
        <report-summary-card
          :reportId="reportId"
          :courseDetails="courseDetails"
          :style="{ marginBottom: '20px' }"
          :isComparative="false"
        />
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
import dashHeader from '@src/views/dashboard/Header.vue';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';
import reportSummaryCard from '@src/views/report/Report-summary-card.vue';
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'report-summary',
  data() {
    return {
      reportId: this.$route.params.reportId,
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'reports',
          route: '/dashboard/reports',
        },
        {
          name: 'Report Summary',
          route: `/dashboard/reports/${this.$route.params.reportId}`,
        },
      ],
      courseSubmitterBreadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'Report Summary',
          route: `/dashboard/reports/${this.$route.params.reportId}`,
        },
      ],
    };
  },
  components: {
    dashHeader,
    dashSidebar,
    reportSummaryCard,
  },
  computed: {
    ...mapGetters('user', {
      userRole: 'getUserRole',
      userToken: 'getUserToken',
    }),
    ...mapState('assessments', {
      combinedReview: state => state.combinedReview,
    }),
    ...mapState('courses', {
      courseDetails: state => state.courseDetails,
    }),
  },
  methods: {
    ...mapActions('assessments', {
      getReportById: 'getReportById',
    }),
    ...mapActions('courses', {
      getCourseById: 'getCourseById',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      if (this.userToken !== undefined) {
        this.getReportById({
          reportId: this.reportId,
          userToken: this.userToken,
        });
      }
    });
  },
  watch: {
    userToken() {
      this.getReportById({
        reportId: this.reportId,
        userToken: this.userToken,
      });
    },
  },
  created() {
    this.unSubscribe = this.$store.subscribe((mutation, state) => {
      // eslint-disable-next-line max-len
      if (mutation.type === 'assessments/REPORTFETCHED') {
        const courseId = state.assessments.combinedReview.report_details.course_id;
        this.getCourseById({ courseId, userToken: this.userToken });
      }
    });
  },
  beforeDestroy() {
    this.unSubscribe();
  },
};
</script>
